/**
 * Determines whether a given value is a valid JSON string.
 *
 * @param value - The value to be checked.
 * @returns A boolean indicating whether the value is a string that can be successfully parsed as JSON.
 */
export function isJSONString(value: unknown): value is string {
  if (typeof value !== 'string') return false
  try {
    JSON.parse(value)
    return true
  } catch {
    return false
  }
}
